export default class ProductShipping {
  constructor(sku, type, details) {
    this.sku = sku;
    this.type = type;

    // At this point, the API only returns these 3 properties for products that
    // are florist delivered and that offer same day delivery. To support dropship,
    // we would need to rethink the data passed and possibly the messaging
    this.destinationFloristCutoff = details.sameDayCutoffUtc ?? null;
    this.destinationFloristCutoffSource = details.sameDayCutoffSource ?? null;
    this.destinationUtcOffsetMinutes = details.recipientUtcOffset ?? null;
  }
}